import React from 'react';

import Awb from '../../../models/Awb';

import style from './driverETA.module.css';

interface DriverAWBTableMobileProps {
  orderListItems: Array<Awb>;
};

const driverAWBTableMobile = (props: DriverAWBTableMobileProps) => {

  const { orderListItems } = props;

  const totalWeight = orderListItems.reduce(function(prev, cur) {
    return prev + parseInt(cur.weight);
  }, 0);

  const totalPieces = orderListItems.reduce(function(prev, cur) {
    let _peieces:any = cur.pieces.toString();
    return prev + parseInt(_peieces);
  }, 0);

  return (
    <div className={ style.tableWrapper }>

      {orderListItems.map((row: any, index: number) => (
        <div key={index}>
          <div className={ style.awbHead }>
            <span>{row.awb}</span>
            <span>{row.pieces}</span>
            <span>{row.weight}K</span>
            <span>{row.org}-{row.dst}</span>
          </div>
          <div>{row.special}</div>
          <div>{row.remarks_text}</div>
          <div className={ style.horizontalLine }></div>
        </div>
      ))}
      <div className={ style.awbHead }>
          <span>Totals:</span>
          <span>{totalPieces}</span>
          <span>{totalWeight}K</span>
          <span></span>
        </div>
    </div>
  );
}

export default driverAWBTableMobile;